import React from 'react';
import { FiActivity, FiShoppingBag, FiHome, FiTruck, FiDollarSign, FiBookOpen } from 'react-icons/fi';

const MvpIndustry = () => {
  const industries = [
    {
      id: 1,
      icon: <FiActivity size={24} />,
      title: "Healthcare & Life Sciences",
      desc: "Compliant health platforms, telemedicine apps, and patient-facing tools built for real-world adoption.",
      features: [
        "HIPAA-ready MVP architecture",
        "Patient data security validation",
        "Provider workflow testing"
      ],
      link: "/"
    },
    {
      id: 2,
      icon: <FiShoppingBag size={24} />,
      title: "Retail, Food & Consumer",
      desc: "E-commerce platforms, food ordering apps, and loyalty systems built for speed and conversion.",
      features: [
        "Customer demand validation",
        "Pricing strategy testing",
        "Sales channel effectiveness"
      ],
      link: "/"
    },
    {
      id: 3,
      icon: <FiHome size={24} />,
      title: "Real Estate & Prop Tech",
      desc: "Property listing platforms, smart home apps, and agent management tools for modern real estate teams.",
      features: [
        "Property search UX validation",
        "Agent workflow optimization",
        "Market adoption testing"
      ],
      link: "/"
    },
    {
      id: 4,
      icon: <FiTruck size={24} />,
      title: "Logistics & Supply Chain",
      desc: "Fleet tracking, dispatch automation, and warehouse management systems that move businesses forward.",
      features: [
        "Real-time tracking validation",
        "Route optimization testing",
        "Driver app adoption metrics"
      ],
      link: "/"
    },
    {
      id: 5,
      icon: <FiDollarSign size={24} />,
      title: "Fintech & Financial Services",
      desc: "Digital wallets, lending platforms, and payment gateways with security-first development practices.",
      features: [
        "Payment flow validation",
        "Regulatory compliance checks",
        "User onboarding testing"
      ],
      link: "/"
    },
    {
      id: 6,
      icon: <FiBookOpen size={24} />,
      title: "EdTech & E-Learning",
      desc: "Learning management systems, course marketplaces, and student engagement tools built to scale.",
      features: [
        "Learner engagement validation",
        "Course completion tracking",
        "Instructor workflow testing"
      ],
      link: "/"
    }
  ];

  return (
    <div className="section section-padding bg-color-light pb-5 mvp-industry-area" style={{ background: "#fbfbfc" }}>
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <h2 className="title mb-3 fw-bold" style={{ fontSize: "36px" }}>
              MVP Development for <span className="text-primary">Every Industry</span>
            </h2>
            <p className="subtitle mb-5 text-muted" style={{ fontSize: "16px" }}>
              We help startups and businesses across industries turn ideas into validated, market-ready products with speed and precision.
            </p>
          </div>
        </div>

        <div className="row g-4 pt-4">
            {industries.map((item) => (
                <div className="col-lg-4 col-md-6 mb-4 d-flex" key={item.id}>
                    <div className="industry-card bg-white p-5 h-100 rounded-4 shadow-sm d-flex flex-column hover-lift-shadow">
                        <div className="icon-wrapper mb-4">
                            <div className="icon-box d-flex align-items-center justify-content-center text-primary bg-primary-light rounded-circle shadow-soft">
                                {item.icon}
                            </div>
                        </div>
                        <h4 className="title mb-3 fw-bold" style={{ fontSize: "22px", color: "var(--color-dark)" }}>{item.title}</h4>
                        <p className="desc text-muted mb-4" style={{ fontSize: "15px", lineHeight: "1.7" }}>{item.desc}</p>

                        <div className="key-solutions mt-2 mb-4">
                            <h6 className="heading text-dark fw-bold mb-3" style={{ fontSize: "15px", letterSpacing: "0.5px", textTransform: "uppercase", opacity: "0.8" }}>Key Solutions</h6>
                            <ul className="list-unstyled mb-0 flex-grow-1">
                                {item.features.map((feature, i) => (
                                    <li key={i} className="mb-3 text-muted d-flex align-items-center fw-medium" style={{ fontSize: "14px" }}>
                                        <span className="solution-dot me-3"></span> {feature}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default MvpIndustry;
